(()=>{
const feedback=()=>document.querySelector('[data-cart-add-feedback]');
const words=()=>{try{return JSON.parse(document.querySelector('[data-cart-add-strings]')?.textContent||'{}');}catch{return {};}};
let feedbackTimer,feedbackFrame,queue=Promise.resolve();
function notify(message,error=false){
 const box=feedback();if(!box)return;
 clearTimeout(feedbackTimer);cancelAnimationFrame(feedbackFrame);
 box.classList.remove('is-visible');box.textContent='';box.dataset.kind=error?'error':'success';
 feedbackFrame=requestAnimationFrame(()=>{box.textContent=message;box.classList.add('is-visible');feedbackTimer=setTimeout(()=>{box.classList.remove('is-visible');box.textContent='';},error?8000:4000);});
}
function preservePosition(change){
 const x=window.scrollX,y=window.scrollY;
 const grids=[...document.querySelectorAll('.choice-grid')].map(el=>({el,left:el.scrollLeft,top:el.scrollTop}));
 change();
 grids.forEach(({el,left,top})=>{el.scrollLeft=left;el.scrollTop=top;});
 window.scrollTo({left:x,top:y,behavior:'instant'});
}
function refresh(result){
 const headerId=document.querySelector('[data-cart-summary]')?.dataset.sectionId;
 const section=result?.sections?.[headerId];
 document.dispatchEvent(new CustomEvent('feitoria:cart-updated',{detail:typeof section==='string'?{section}:{}}));
}
async function send(url,payload){
 const headerId=document.querySelector('[data-cart-summary]')?.dataset.sectionId;
 const context=new URL(window.location.href);
 context.searchParams.delete('sections');context.searchParams.delete('section_id');
 const sectionUrl=context.pathname+context.search;
 let body,headers={Accept:'application/json'};
 if(payload instanceof FormData){
  body=new FormData();for(const [key,value] of payload.entries())body.append(key,value);
  body.delete('return_to');
  if(headerId){body.set('sections',headerId);body.set('sections_url',sectionUrl);}
 }else{
  body=JSON.stringify({...payload,...(headerId?{sections:[headerId],sections_url:sectionUrl}:{})});
  headers['Content-Type']='application/json';
 }
 try{
  const response=await fetch(url,{method:'POST',headers,body});
  const result=await response.json();
  if(!response.ok)throw new Error(typeof result.description==='string'?result.description:words().error);
  if(!Array.isArray(result.items)&&!result.id)throw new Error(words().error);
  refresh(result);
  return result;
 }catch(error){
  refresh();
  throw new Error(((error instanceof TypeError||error instanceof SyntaxError)?words().error:(error.message||words().error))+' '+words().check_cart);
 }
}
function add(url,payload){
 const job=queue.then(()=>send(url,payload));
 queue=job.catch(()=>{});
 return job;
}
function lock(scope){
 const controls=[...scope.querySelectorAll('button,input,select,textarea')].map(el=>({el,disabled:el.disabled}));
 controls.forEach(({el})=>el.disabled=true);
 scope.setAttribute('aria-busy','true');
 return()=>{controls.forEach(({el,disabled})=>{if(el.isConnected)el.disabled=disabled;});scope.removeAttribute('aria-busy');};
}
window.FeitoriaCartAdd={add,notify,preservePosition,lock,words,refresh,success:()=>notify(words().success)};
function syncCardQuantity(form,normalize=false){
 const input=form?.querySelector('[data-card-quantity]');if(!input)return;
 const min=Math.max(1,Number(input.min)||1),step=Math.max(1,Number(input.step)||1);
 const rawMax=input.max===''?Infinity:Number(input.max),max=Number.isFinite(rawMax)?Math.max(min,rawMax):Infinity;
 let value=Number(input.value);
 if(normalize){value=Math.max(min,Math.min(max,min+Math.round(((Number.isFinite(value)?value:min)-min)/step)*step));input.value=String(value);}
 const busy=form.dataset.adding==='true';
 const minus=form.querySelector('[data-card-qty-action="minus"]'),plus=form.querySelector('[data-card-qty-action="plus"]');
 if(minus)minus.disabled=busy||!Number.isFinite(value)||value<=min;
 if(plus)plus.disabled=busy||value>=max;
}
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-card-qty-action]');if(!button||button.disabled)return;
 const form=button.closest('[data-ajax-cart-add]'),input=form?.querySelector('[data-card-quantity]');
 if(!input||form.dataset.adding==='true')return;
 event.preventDefault();syncCardQuantity(form,true);
 if(button.dataset.cardQtyAction==='plus')input.stepUp();else input.stepDown();
 syncCardQuantity(form,true);
});
document.addEventListener('input',event=>{if(event.target.matches('[data-card-quantity]'))syncCardQuantity(event.target.form);});
document.addEventListener('change',event=>{if(event.target.matches('[data-card-quantity]'))syncCardQuantity(event.target.form,true);});

document.addEventListener('submit',async event=>{
 const form=event.target;
 if(event.defaultPrevented||!(form instanceof HTMLFormElement)||!form.matches('[data-ajax-cart-add]'))return;
 event.preventDefault();
 if(form.dataset.adding==='true')return;
 if(!form.reportValidity())return;
 form.dataset.adding='true';
 const payload=new FormData(form);
 const submit=event.submitter||form.querySelector('[type="submit"]'),contents=submit?[...submit.childNodes].map(node=>node.cloneNode(true)):[];
 const unlock=lock(form);
 if(submit&&!submit.matches('[data-card-add]'))submit.textContent=words().adding;
 try{
  const url=new URL(form.action,window.location.origin);url.pathname=url.pathname.replace(/\/$/,'')+'.js';url.search='';
  await add(url.href,payload);
  preservePosition(()=>HTMLFormElement.prototype.reset.call(form));
  window.FeitoriaCartAdd.success();
 }catch(error){notify(error.message,true);}
 finally{unlock();form.dataset.adding='false';if(submit)submit.replaceChildren(...contents);syncCardQuantity(form);}
});
})();